import React, { useEffect, useState } from "react";
import "./style.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import SuccessIcon from "../../icons/SuccessIcon.svg";
import ErrorIcon from "../../icons/ErrorIcon.svg";
import WarningIcon from "../../icons/infoIcon.svg";


export interface SuccessPopupProps {
  show: boolean;
  type?: "success" | "error" | "warning";
  title?: string;
  message?: string;
  duration?: number; // in ms
  onClose?: () => void;
}

const Alert: React.FC<SuccessPopupProps> = ({
  show,
  message = "",
  type = "success",
  title,
  duration = 3000,
  onClose,
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!show) return;

    setProgress(0);
    const start = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      setProgress(newProgress);

      if (elapsed >= duration) {
        clearInterval(interval);
        onClose?.();
      }
    }, 16); // ~60fps

    return () => clearInterval(interval);
  }, [show, duration, onClose]);

  if (!show) return null;

  const getBackgroundImage = () => {
    switch (type) {
      case "success":
        return SuccessIcon;
      case "error":
        return ErrorIcon;
      case "warning":
        return WarningIcon;
      default:
        return SuccessIcon;
    }
  };

  const getHeading = () => {
    if (title) return title;

    switch (type) {
      case "error":
        return "Error Occurred";
      case "warning":
        return "Warning";
      case "success":
        return "Success";
      default:
        return "Success";
    }
  };

  const backgroundImage = getBackgroundImage();
  const heading = getHeading();
                     
  return (
    <div className={`${type}-popup`} style={{ display: show ? "block" : "none", backgroundImage: `url(${backgroundImage})` }}>
      <button className="close-btn" onClick={onClose}>
        ✕
      </button>
      <div className="popup-content">
      </div>
      <div className="d-flex popup-heading text-capitalize"><p>{heading}</p></div>
      <div className="d-flex popup-content"><p>{message}</p></div>
      <div
        key={Date.now()}
        className="popup-progress-bar my-2"
        style={{
          width: `${progress}%`,
          transition: "width 0.05s linear",
        }}
      />
    </div>
  );
};

export default Alert;
